<template>
  <div class="recent-dynamic">
    <FeedListItem
      v-for="(d, i) in dynamicList"
      :key="'dynamic-' + d.id + '-' + i"
      class="dynamic-one"
      :info="d"
      :boutiqueList="boutiqueList"
    />
  </div>
</template>
<script>
import FeedListItem from './feed-list-item';
export default {
  name: 'RecentDynamic',
  components: {
    FeedListItem
  },
  props: {},
  data() {
    return {
      dynamicList: [],
      isLoading: false,
      finished: false,
      lastRecommendResult: {}, //上一次请求回来的动态数据
      pageIndex: 1,
      pageSize: 6,
      total: null,
      params: {},
      excludeIds: [],
      boutiqueList: []
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.addScrollEventListener();
  },
  beforeDestroy() {
    this.removeScrollEventListener();
  },
  created() {
    // 只能在devops.nicee.app里做加精操作
    try {
      const hostName = this.getParentUrl();
      if (hostName == 'https://devops.nicee.app/' || (this.$route.query && this.$route.query.hostName == 'devops')) {
        this.getDefaultList();
        this.getBoutiqueList();
      } else {
        this.$router.push({ path: '/home' });
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    getParentUrl() {
      let url = null;
      if (parent !== window) {
        try {
          url = parent.location.href;
        } catch (e) {
          url = document.referrer;
        }
      }
      return url;
    },
    addScrollEventListener() {
      /**
       * 陪陪详情页动态显示弹窗滚动
       */
      this.scrollDom = document.getElementById('page-main');
      if (this.scrollDom)
        this.scrollDom.addEventListener('scroll', this.getMoreList);
    },
    removeScrollEventListener() {
      if (this.scrollDom)
        this.scrollDom.removeEventListener('scroll', this.getMoreList);
      if (this.timer) clearTimeout(this.timer);
    },
    getDefaultList() {
      this.params = {
        size: 5
      };
      this.getList();
    },
    getList() {
      if (this.isLoading || this.finished || !this.params) return;
      this.isLoading = true;
      return this.$http
        .post('/moment/square/latest', this.params)
        .then(({ data }) => {
          if (this.isRecommend) {
            if (
              data &&
              data.momentVo &&
              data.momentVo.pageContent &&
              data.momentVo.pageContent.length
            ) {
              this.dynamicList = this.dynamicList.concat(
                data.momentVo.pageContent
              );
            } else {
              this.finished = true;
            }
            this.lastRecommendResult = data;
            // this.pageIndex += 1;
            this.excludeIds =
              this.dynamicList && this.dynamicList.length
                ? this.dynamicList.map(item => {
                    return item.id.toString();
                  })
                : [];
            this.params = {
              pageSize: this.pageSize,
              max: this.lastRecommendResult.max,
              mix: this.lastRecommendResult.mix,
              seed: this.lastRecommendResult.seed,
              pageIndex: this.pageIndex,
              excludeIds: this.excludeIds
            };
            this.total = data.momentVo.totalRemain;
          } else {
            if (data && data.length) {
              this.dynamicList = this.dynamicList.concat(data);
              this.params.lastId = data[data.length - 1].createTime;
            } else {
              this.finished = true;
            }
          }
          this.isLoading = false;
          this.$emit('getFeed', this.dynamicList);
        })
        .catch(err => {
          console.log(err);
          this.$emit('getFeed', this.dynamicList);
          this.isLoading = false;
        });
    },
    getMoreList(ev) {
      const { scrollTop, clientHeight, scrollHeight } = ev.target;
      if (scrollTop + clientHeight + 150 >= scrollHeight) {
        this.getList();
      }
    },
    async getBoutiqueList() {
      try {
        const { data } = await this.$http.get('/moment/moment/digest/list');
        if (data) {
          this.boutiqueList = JSON.parse(data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.recent-dynamic {
  background-color: white;
}
</style>
